$(document).ready(function () {
    window.get_global_status = function (status) {
        let icon = status == "1" ? "far fa-thumbs-up" : "far fa-thumbs-down";
        let title = status == "0" ? "Desactivada" : "Activada";
        let color_class = status == "1" ? "success" : "danger";
        let text = status == "1" ? "Activo" : "Desactivado";
        return {'icon': icon, 'title': title, 'color_clas': color_class,'text':text};
    }

    window.getColorBagdeInStatus = function ($estado) {
        row.status === 1
        if (row.status === 1) {
            return "<span class='badge badge-success' style='width: 30px; height: 30px; display: inline-block;'><i class='fa fa-2x fa-check' aria-hidden='true'></i></span>";
        } else {
            return "<span class='badge badge-danger' style='width: 30px; height: 30px; display: inline-block;'><i class='fa fa-2x fa-times' aria-hidden='true'></i></span>";
        }
    }

    window.alertSuccess = function(msg)
    {
        Swal.fire({
            position: 'center',
            icon: "success",
            title: msg,
            showConfirmButton: false,
            timer: 1500,
        })
    }

    window.alertError = function(msg)
    {
        Swal.fire({
            position: 'center',
            icon: "error",
            title: msg,
            showConfirmButton: true,
        })
    }
});

